import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import NextPages from "../components/NextPages"
import placeStyles from "../styles/templates/place.module.scss"
import Img from 'gatsby-image'



export default function Place(props) {
  const data = props.data.markdownRemark;
  return (
    <Layout>

      <article id="place" className={placeStyles.place}>
        <figure className={placeStyles.place__hero}>
          <Img
            fluid={data.frontmatter.hero_image.childImageSharp.fluid}
            alt={data.frontmatter.title}
          />
        </figure>
        
        <div className={placeStyles.place__info}>
          <h1>{data.frontmatter.title}</h1>
        </div>
        <div
          className={placeStyles.place__body}
          dangerouslySetInnerHTML={{ __html: data.html }}
        />

        <NextPages
          currentRegion={data.frontmatter.location.region} 
          isRegion={data.frontmatter.location.is_region}
          currentPlace={data.frontmatter.title} 
        />
      </article>
      
    </Layout>
  )
}


export const getPlaceData = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      fields {
        slug
      }
      frontmatter {
        title
        description
        location {
          is_region
          region
        }
        hero_image {
          childImageSharp {
            fluid(maxWidth: 825) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      html
    }
  }
`